import React from "react";
import styled from "styled-components";
import FeaturePanel from "@nib-components/feature-panel";
import Link from "@nib-components/link";
import {
  DocumentGraphicIcon,
  ClockGraphicIcon,
  CinemaGraphicIcon,
  DoctorGraphicIcon,
} from "@nib/icons";
import Container from "@nib-components/container";
import { Margin } from "styled-components-spacing";
import { breakpoint } from "styled-components-breakpoint";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Copy from "@nib-components/copy";
import { colorSunsetPink40, colorTrueGreen } from "@nib-components/theme";

import "swiper/swiper.min.css";

import "swiper/components/pagination/pagination.min.css";
import Heading from "@nib-components/heading";
import { Box, Inline, Stack } from "@nib/layout";

SwiperCore.use([Pagination]);

const StyledFeaturePanel = styled(FeaturePanel)`
  margin-top: 3rem;
  background-color: ${colorSunsetPink40};
`;

const StyledContainerHiddenOnMobile = styled.div`
  width: 100%;
  background-color: ${colorSunsetPink40};
  display: none;

  ${breakpoint("lg")`
    display: block;
  `};
`;
const StyledContainerVisibleOnMobile = styled.div`
  width: 100%;
  background-color: ${colorSunsetPink40};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0;

  ${breakpoint("lg")`
    display: none;
  `};
`;

const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;

  .swiper-slide {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
  }
  .swiper-pagination {
    position: unset;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .swiper-pagination-bullets {
    .swiper-pagination-bullet {
      margin: 0 0.5rem;
      background-color: ${colorTrueGreen};
    }
  }
`;

const StyledStack = styled(Stack)`
  margin-bottom: 2rem;
  text-align: center;

  p {
    text-align: center;
  }
  button {
    text-align: center;
  }
`;

const EducationFeaturePanel = ({ onClick }) => {
  return (
    <Margin vertical={{ xs: 7, md: 9 }}>
      <StyledContainerHiddenOnMobile>
        <Container background="sunsetPink40">
          <StyledFeaturePanel title="What is involved?">
            <FeaturePanel.Feature icon={DoctorGraphicIcon} title="Trusted experts">
              Created in partnership with trusted{" "}
              <Link as="button" onClick={onClick}>
                Australian pregnancy experts
              </Link>
              .
            </FeaturePanel.Feature>
            <FeaturePanel.Feature icon={DocumentGraphicIcon} title="Learn in your own time">
              Learn at your own pace with lifetime access to the courses.
            </FeaturePanel.Feature>
            <FeaturePanel.Feature
              icon={ClockGraphicIcon}
              title="Over 12 hours of learning material"
            >
              Broken down into small, manageable chunks.
            </FeaturePanel.Feature>
            <FeaturePanel.Feature icon={CinemaGraphicIcon} title="Video content">
              A mix of video and supporting written content.
            </FeaturePanel.Feature>
          </StyledFeaturePanel>
        </Container>
      </StyledContainerHiddenOnMobile>
      <StyledContainerVisibleOnMobile>
        <div>
          <Heading size={3} as="h2">
            What is involved?
          </Heading>
        </div>
        <StyledSwiper
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return (
                '<button class="' +
                className +
                '" tabIndex="0" aria-label="Go to slide ' +
                (index + 1) +
                '"' +
                "></button>"
              );
            },
          }}
          keyboard
          centeredSlides
          spaceBetween={30}
          slidesPerView={2}
        >
          <SwiperSlide>
            <StyledStack space={4}>
              <DoctorGraphicIcon size="xl" />
              <Heading size={4}>Trusted experts</Heading>
              <Copy>
                Created in partnership with trusted{" "}
                <Link href="javascript:;" onClick={onClick}>
                  Australian pregnancy experts
                </Link>
              </Copy>
            </StyledStack>
          </SwiperSlide>

          <SwiperSlide>
            <StyledStack space={4}>
              <DocumentGraphicIcon size="xl" />
              <Heading size={4}>Learn in your own time</Heading>
              <Copy>Learn at your own pace with lifetime access to the courses.</Copy>
            </StyledStack>
          </SwiperSlide>
          <SwiperSlide>
            <StyledStack space={4}>
              <ClockGraphicIcon size="xl" />
              <Heading size={4}>Over 12 hours of learning material</Heading>
              <Copy>Broken down into small, manageable chunks.</Copy>
            </StyledStack>
          </SwiperSlide>
          <SwiperSlide>
            <StyledStack space={4}>
              <CinemaGraphicIcon size="xl" />
              <Heading size={4}>Video content</Heading>
              <Copy>A mix of video and supporting written content.</Copy>
            </StyledStack>
          </SwiperSlide>
        </StyledSwiper>
      </StyledContainerVisibleOnMobile>
    </Margin>
  );
};

export default EducationFeaturePanel;
